import { useContext } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import MascotView from '../housekiosk/components/Mascot/MascotView';
import { UserContext } from '../contexts/UserContext';
import { getHouseIdFromProfile } from '../housekiosk/utils';

export default function HouseKioskMascotPage() {
  const { userProfile } = useContext(UserContext);
  const { houseId } = useParams<{ houseId?: string }>();
  const role = (userProfile?.mainRole || '').toUpperCase();
  const isMascot = role.includes('MASCOT');

  if (!isMascot) {
    return <Navigate to="/unauthorized" replace />;
  }

  const resolvedHouseId = houseId ?? getHouseIdFromProfile(userProfile);

  return <MascotView houseId={resolvedHouseId} />;
}
